module.exports = __webpack_public_path__ + "img/image16.89b2596b.jpg";